import React from 'react';
import { Box } from '@mui/material';
import {
  Business as BusinessIcon,
  Gavel as GavelIcon,
  People as PeopleIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
  CalendarToday as CalendarIcon,
  Assignment as TaskIcon,
  CheckCircle as CheckIcon,
  Warning as AlertIcon,
} from '@mui/icons-material';
import { FirmAdminStats } from '../../../types/statistics';
import { StatCard } from '../StatCard';
import { DashboardTabs } from '../DashboardTabs';

interface FirmAdminViewProps {
  data: FirmAdminStats;
}

export const FirmAdminView: React.FC<FirmAdminViewProps> = ({ data }) => {
  return (
    <DashboardTabs overviewType="admin">
      {/* Practice Overview */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Total Cases"
            value={data.total_cases}
            icon={<GavelIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Active Cases"
            value={data.active_cases}
            icon={<GavelIcon />}
            color="#16a34a"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Completed Cases"
            value={data.completed_cases}
            icon={<CheckIcon />}
            color="#9333ea"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Total Clients"
            value={data.total_clients}
            icon={<PeopleIcon />}
            color="#dc2626"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Active Clients"
            value={data.active_clients}
            icon={<PeopleIcon />}
            color="#0891b2"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Team Members"
            value={data.team_members}
            icon={<PeopleIcon />}
            color="#7c3aed"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Lawyers"
            value={data.lawyers}
            icon={<GavelIcon />}
            color="#059669"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Staff Members"
            value={data.staff_members}
            icon={<PeopleIcon />}
            color="#ea580c"
          />
        </Box>
      </Box>

      {/* Performance Metrics */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Success Rate"
            value={data.success_rate}
            icon={<TrendingUpIcon />}
            color="#16a34a"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Avg Case Duration"
            value={data.average_case_duration}
            icon={<CalendarIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Monthly Revenue"
            value={data.monthly_revenue}
            icon={<MoneyIcon />}
            color="#16a34a"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Yearly Revenue"
            value={data.yearly_revenue}
            icon={<MoneyIcon />}
            color="#9333ea"
          />
        </Box>
      </Box>

      {/* Tasks */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Pending Tasks"
            value={data.pending_tasks}
            icon={<TaskIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Overdue Tasks"
            value={data.overdue_tasks}
            icon={<AlertIcon />}
            color="#dc2626"
          />
        </Box>
      </Box>

      {/* Tasks & Hearings */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Upcoming Hearings"
            value={data.upcoming_hearings}
            icon={<CalendarIcon />}
            color="#9333ea"
          />
        </Box>
      </Box>
    </DashboardTabs>
  );
};
